export { default as searchIcon } from "./search_white.svg";
